<template>
	<div>
		<indexHeader ref="indexHeader"></indexHeader>
		<div class="check load_inLeft">
		  <!--<div class="status" v-if="state == 2">-->
		    <!--<img src="/static/images/error.png" width="192px" height="174px">-->
		    <!--<h3>未完成规定学时暂不允许考试</h3>-->
		    <!--<p>请您完成3学时学习内容后再来参加考试</p>-->
		    <!--<a href="/module/index.html" class="back">返回首页</a>-->
		  <!--</div>-->
		  <div class="status">
		    <img src="/static/images/pass.png" width="160px" height="160px">
		    <h3>提交成功</h3>
		    <p>您的资料已提交成功，等待人工审核，通过后将由e照通提醒，请关注并绑定</p>
		    <div class="tx">
		      <span>政务信息提醒</span>
		      <span>信用信息提醒</span>
		      <span>证书业务提醒</span>
		    </div>
		    <img :src="qrCodeUrl" alt="" width="140px" height="140px" style="margin-top:60px ">
		    <p class="iconfont shuaxin " @click="saoma()">刷新</p>
		    <div class="qrCode_p">关注并绑定</div>
		    <router-link to="/" class="back">返回首页</router-link>
		    <!--<div class="join">参加考试</div>-->
		  </div>
		</div>
		<indexFooter></indexFooter>
	</div>
  
</template>

<script>
	import { cookie } from "@/common/js/cookies.js";
	import indexHeader from "@/components/index/index_header";
	import indexFooter from "@/components/index/index_footer";
export default {
  name: "index_ddsh",
  data() {
    return {
      qrCodeUrl: null
    };
  },
  mounted() {
    document.getElementsByClassName("header")[0].style.background = "#fff";
    this.saoma();
  },
  components: {
    indexHeader,
    indexFooter
  },
  methods: {
    saoma() {
      let _self = this;
      let ajax = _self.$http.create();
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      ajax({
        method: "post",
        url: SOWINURL + "report/saoma",
        data: {
          iphone: _self.$route.query.tel
        },
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
      })
        .then(function(json) {
          // console.log(json.data);
          if (json.data.result == 1) {
            if (json.data.data.saoma) {
              _self.qrCodeUrl = json.data.data.saoma.qrCodeUrl;
            } else {
              _self.qrCodeUrl = null;
            }
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error"
            });
          }
          loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped lang="less" type="text/less">
.status {
  // width: 1210px;
  width: 1180px;
  margin: 20px auto;
  padding-top: 130px;
  background: #fff;
  text-align: center;
  padding-bottom: 200px;
  .shuaxin {
    text-align: center;
    color: cornflowerblue;
    text-decoration: underline;
    line-height: 30px;
    font-size: 16px;
    cursor: pointer;
    width: 100px;
    margin: 0 auto;
  }
  .qrCode_p {
    height: 33px;
    line-height: 33px;
    text-align: center;
    font-size: 14px;
    color: #000;
  }
  .tx {
    text-align: center;
    span {
      display: inline-block;
      font-size: 14px;
      color: #0076ff;
      margin: 0 20px;
    }
  }
  .back,
  .join {
    width: 158px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 24px;
    border: 1px solid #0374ff;
    font-size: 18px;
    color: #0374ff;
    display: inline-block;
    margin: 100px 20px 0 20px;
  }

  .join {
    color: #fff;
    border: none;
    width: 160px;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    background: -webkit-linear-gradient(
      left,
      #0076ff,
      #00c9ff
    ); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(
      right,
      #0076ff,
      #00c9ff
    ); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(
      right,
      #0076ff,
      #00c9ff
    ); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #0076ff, #00c9ff); /* 标准的语法 */
  }

  img {
    display: block;
    margin: 0 auto;
  }

  h3 {
    height: 90px;
    line-height: 90px;
    text-align: center;
    font-size: 30px;
    color: #02113a;
  }

  p {
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 16px;
    color: #070d4b;
    /*margin-bottom: 100px;*/
  }
}
.exam {
  padding: 50px 100px;
  background: #fff;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index_ddsh.vue